import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { Drawer } from "devextreme-react/drawer";
import { List } from "devextreme-react/list";
import { Switch,TextBox } from "devextreme-react";
import axios from "axios";
import data from "../assets/apiRoutes.json";
import notify from 'devextreme/ui/notify';

const Permission = (props) => {
  const rolePermissions = props.rolePermissions || [];
  console.log("rolePermissions:", JSON.stringify(rolePermissions, null, 2));
  const [selectedModules, setSelectedModules] = useState([]);
  const [searchedText, setSearcgedText] = useState('');
  const menuItems = [
    ...new Set(rolePermissions.map(({ module, moduleFullName  }) => JSON.stringify({ module, moduleFullName })))
  ]
    .map(JSON.parse)
    .sort((a, b) => {
      if (a.module === "Security") return 1;
      if (b.module === "Security") return -1;
      return a.module.localeCompare(b.module);
    })
    .map(({ module, moduleFullName }) => ({
      id: module,
      text: moduleFullName,
      icon: "showpanel",
    }));

  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setSearcgedText('');
    setSelectedItem(menuItems[0]);
  }, [props.popupOpen])
  useEffect(() => {
    if (props.popupOpen === false)
      return;
    if (selectedItem) {
      const permission = rolePermissions.filter(item => item.module === selectedItem.id);
      setSelectedModules(permission);
    }
  }, [selectedItem]);

  const filterByGroupAndPermission = (data, searchtext) => {
    let filterdModule = data.filter(m => m.groupFullName.toLowerCase().includes(searchtext.toLowerCase()));
    let module = data
      .map(module => {
        const filteredPermissions = module.permissions.filter(permission =>
          permission.permissionFullName.toLowerCase().includes(searchtext.toLowerCase())
        );
        if (filteredPermissions.length > 0) {
          const existingPermissions = filterdModule.flatMap(m => m.permissions || []);
          const uniquePermissions = filteredPermissions.filter(
            permission => !existingPermissions.some(ep => ep.permissionFullName === permission.permissionFullName)
          );
  
          if (uniquePermissions.length > 0) {
            return { ...module, permissions: uniquePermissions };
          }
        }
        return null;
      })
      .filter(module => module !== null);
    return module.concat(filterdModule);
  };
  const onSearchPermissions = (e) => {
    let searchtext = e.event.target.value.toString();
    let filterPermissions = [];
    if (e.event.target.value !== "") {
      filterPermissions = filterByGroupAndPermission(rolePermissions, searchtext);
      setSelectedModules(filterPermissions);
    }
    else {
      setSelectedItem(menuItems[0]);
    }
    setSearcgedText(searchtext);

  }
  const onSelectPermission = (e, p, key) => {
    if (p.isChecked === e.value || e.event === undefined) return;
    let getPermissionFromStore = [...rolePermissions];
    let perms = [];
    getPermissionFromStore.forEach((resetPerm) => {
      resetPerm.permissions.forEach((permission) => {
        if (resetPerm.key === key && permission.title === p.title) {
          permission.isChecked = e.value;
          let modules = [];
          if (searchedText !== '')
            modules = filterByGroupAndPermission(getPermissionFromStore, searchedText);
          else
            modules = getPermissionFromStore.filter(m => m.module === resetPerm.module);
          setSelectedModules(modules);
        }
        if (permission.isChecked === true) {
          perms.push(`${resetPerm.key + permission.title}`);
        }
      });
    });
    axios
      .post(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.AddRolePermissions}?roleName=${props.role}&groupName=${key}`,
        perms
      )
      .then((resp) => {
        notify(
          {
            message: 'Permission Saved Successfully',
            width: 400,
          },
          'success',
          3000,
        );


      })
      .catch((err) => {
        notify(
          {
            message: 'Error: Permission is not Saved Successfully',
            width: 400,
          },
          'error',
          3000,
        );
        console.log(err);
      });
  };
  return (
    <div className='row' style={{ height: '100%' }}>
    <div className='col-md-2' style={{ height: '100%' }}>
        <Drawer
          opened={true}
          closeOnOutsideClick={false}
          openedStateMode="shrink"
          position="left"
          revealMode="expand"
          shading={false}
        >
          <List
            items={menuItems}
            selectedItem={selectedItem}
            selectionMode="single"
            keyExpr="id"
            displayExpr="text"
            onItemClick={(e) => { setSelectedItem(e.itemData); setSearcgedText(''); }}
          />
        </Drawer>
      </div>
      <div className='col-md-9'>
        <div className='col-md-12 search-box'>
          <TextBox
            placeholder="Search..."
            stylingMode="outlined"
            width={450}
            value={searchedText}
            onInput={(e) => onSearchPermissions(e)}
          >
              <i className="dx-icon dx-icon-search" style={{color: "var(--dx-button-normal-bg)", position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}></i>

            </TextBox>
        </div>
        {selectedModules && selectedModules.map((module, i) => (
          <div className='main-card' key={i}>
            {searchedText !== '' && (<p style={{ marginTop: '12px' }}><b>{module.moduleFullName}</b></p>)}

            <p className='group-title'>
              {module.groupFullName}

            </p>
            <div className='settings-card'>
              {module.permissions.map((p) => (
                <div className='row settings-card-row' key={p.permissionFullName}>
                  <div className='col-md-12'>
                    {
                      p.permissionFullName
                    }

                  </div>
                  <div className='col-md-9'>
                    <span className="card-item-info">{p.description}</span>
                  </div>
                  <div className='col-md-3'>
                    <Switch value={p.isChecked} onValueChanged={(e) => onSelectPermission(e, p, module.key)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(Permission);